import PropTypes from 'prop-types';
import QuizDetailsLanding from '@cont/DST/Details/Landing';
import QuizTakingLanding from '@cont/DST/Taking/Landing/Landing';
import {
  getAllQuestionsBySection,
  getCurrentSessionUID,
  getQuizDetails
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import BaseLayout from '@cont/Quiz/Common/BaseLayout';
import isEmptyObject from '@utils/isEmptyObject';
import { useRouter } from 'next/router';

const Layout = ({ children }) => {
  const {
    query: { quizUID }
  } = useRouter();

  const currentSessionUID = useSelectorWithShallowEqual(getCurrentSessionUID);
  const questionList = useSelectorWithShallowEqual(getAllQuestionsBySection);
  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  if (
    currentSessionUID &&
    !isEmptyObject(questionList) &&
    !isEmptyObject(quizDetails)
  ) {
    return (
      <>
        {children}
        <QuizTakingLanding />
      </>
    );
  }

  return (
    <>
      {children}
      <BaseLayout>
        <QuizDetailsLanding />
      </BaseLayout>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
